import { MdOutlineMail } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { ImWhatsapp } from "react-icons/im";

import React, { useRef } from "react";
import { sendForm } from "@emailjs/browser";

import "./contact.css";
const Contact = () => {
  const form = useRef("");

  const emailjs = {
    key: "h7VWLEdJkr5NjNhjS",
    tempid: "template_3as5rq9",
    servid: "service_4ciw5qh",
  };

  const sendEmail = (e) => {
    e.preventDefault();

    sendForm(emailjs.servid, emailjs.tempid, form.current, emailjs.key).then(
      (result) => {
        console.log(result.text);
      },
      (error) => {
        console.log(error.text);
      }
    );
  };

  return (
    <section id="contact">
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact_container">
        <div className="send_detail">
          <article className="send_report">
            <MdOutlineMail className="mail_icon" />
            <h5>Email</h5>
            <h5>rahulbatham767@gmail.com</h5>
            <h5>
              <a
                href="mailto:rahulbatham767@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                Send a message
              </a>
            </h5>
          </article>
          <article className="send_report">
            <RiMessengerLine className="Messanger" />
            <h5>Messenger</h5>
            <h5>Rahul Batham</h5>
            <h5>
              <a
                href="https://www.facebook.com/rahul.batham.3726613"
                target="_blank"
                rel="noreferrer"
              >
                Send a message
              </a>
            </h5>
          </article>
          <article className="send_report">
            <ImWhatsapp imwhatsaap-icon="true" />
            <h5>Whatsapp</h5>
            <h5>Whatsapp</h5>
            <h5>+7999******</h5>
            <h5>
              <a
                href="http://api.whatsapp.com/send?phone=7999754170"
                target="_blank"
                rel="noreferrer"
              >
                send a message
              </a>
            </h5>
          </article>
        </div>
        {/* End of contact option */}
        <form ref={form} onSubmit={sendEmail} className="child_info">
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Enter Your Name"
            required
          />
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Your Email"
            required
          />
          <textarea
            name="message"
            id="message"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>
          <input
            type="submit"
            className="btn btn-primary"
            value="Send Message"
          />
        </form>
      </div>
    </section>
  );
};

export default Contact;
